import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "-0.5 -0.5 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M3.125 1.875h8.75s1.25 0 1.25 1.25v8.75s0 1.25-1.25 1.25h-8.75s-1.25 0-1.25-1.25v-8.75s0-1.25 1.25-1.25M5.625 1.875v11.25" }, null, -1),
    _createElementVNode("path", { d: "M8.75 5.625 10.625 7.5 8.75 9.375" }, null, -1)
  ]))]))
}
export default { render: render }